$(function(){
    searchAndSetArticles()

    $('#columns').on('click', function(){
        toggleArticles({page:1}, $(this))
    })
    $('#news').on('click', function(){
        toggleArticles({page:1}, $(this))
    })

    $('body').on('click', '.paginate-link', function() {
        const type_id = $(this).attr('data-type')
        const page = $(this).attr('data-page')
        setCurrentTabParams({'data-page':page})
        searchAndSetArticles({page: page}, type_id)
        $(window).scrollTop($('.columns-page-main-title').position().top)
    })

    $('body').on('click', '.sidebar-link', function() {
        const key = $(this).attr('data-key')
        const value = $(this).attr('data-value')
        setCurrentTabParams({'data-key':key, 'data-value':value})
        searchAndSetArticles({key: key, value:value})
    })
    $('body').on('click', '#reset-button', function() {
        if (window.confirm('検索条件をリセットして再度表示し直します。よろしいですか？')) {
            // リロードするだけ
            location.href='/columns'
        }
    })
})

searchAndSetArticles = function(data={} ,current_show_type = '0') {
    /*
    サイドバーから飛んでCOLUMNSとNEWSを切り替える場合はタブにdata-key,data-value属性などを一時的にセットし、
    それを頼りに再リクエストして表示するようにする
    */
    let current_tab = $('#'+getTypeName(current_show_type))
    if (current_tab.attr('data-key') !== '') {
        let key = current_tab.attr('data-key')
        let value = current_tab.attr('data-value')
        data = {key:key, value:value}
    }
    if (current_tab.attr('data-page') !== '') {
        let type = current_tab.attr('data-type')
        let page = current_tab.attr('data-page')
        data['page'] = page
        if (type !== undefined) {
            current_show_type = type
        }
    }
    let result = search(data, current_show_type)
    result.done((res)=>{
        setArticles(res, current_show_type)
    }).fail((error)=>{
        console.log(error)
    })
}
toggleArticles = function(data = {}, current_tab) {
    /*
    サイドバーから飛んでCOLUMNSとNEWSを切り替える場合はタブにdata-key,data-value属性などを一時的にセットし、
    それを頼りに再リクエストして表示するようにする
    */
    if (current_tab.attr('data-key') !== '') {
        let key = current_tab.attr('data-key')
        let value = current_tab.attr('data-value')
        data['key'] = key
        data['value'] = value
    }
    if (current_tab.attr('data-page') !== '') {
        let page = current_tab.attr('data-page')
        data['page'] = page
    }
    let current_show_type = current_tab.attr('id') === 'columns' ? 0 : 1;
    let result = search(data)
    result.done((res)=>{
        if ($('label#'+getTypeName(current_show_type)+'.item-tab').attr('data-count') === 0) {
            // 結果がない場合は検索結果をそのままセットする
            setArticles(res, current_show_type)
        } else {
            // 結果が残っている場合は検索結果はページネーションのリセットにのみ利用する
            setArticleDataCount(res[0].total, res[1].total)
            setArticleCounts()
            clearPagination()
            setPagination(res[current_show_type], current_show_type)
        }
    }).fail((error)=>{
        console.log(error)
    })
}

getTypeName = function(type_id) {
    if (type_id == '1') return 'news';
    return 'columns';
}

setArticleDataCount = function(column_total, news_total) {
    $('label#columns.item-tab').attr('data-count', column_total)
    $('label#news.item-tab').attr('data-count', news_total)
    // 0件ならクリックできないようにしておく
    $('#columns').prop('disabled', column_total === 0)
    $('#news').prop('disabled', news_total === 0)
}

// 検索結果が何件あるのかをdata-count属性にセットされている値をもとに表示する
setArticleCounts = function() {
    let column_total = $('label#columns.item-tab').attr('data-count')
    $('label#columns.item-tab').text('COLUMNS ('+column_total+')')
    let news_total = $('label#news.item-tab').attr('data-count')
    $('label#news.item-tab').text('NEWS ('+news_total+')')
}

// 検索結果によってどっちのタブが選択されるかわからないので両方にセットしておく(リセットは''を指定して行う)
setCurrentTabParams = function(params) {
    let tabs = ['#columns', '#news']
    Object.keys(params).forEach(key => {
        let name = key
        let val = params[key]
        tabs.forEach(tab=>{
            $(tab).attr(name, val)
        })
    })
}

// 検索リクエストを送る部分
search = function(data) {
    return $.ajax({
        type: 'post',
        url: '/columns/search',
        dataType: 'json',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data:data,
    })
}

searchConditionReset = function() {
    setCurrentTabParams({'data-key':'', 'data-value':'', 'data-page':''})
}

clear = function() {
    clearPagination()
    clearContents()
}

clearPagination = function() {
    // pagination
    $('#columns-contents .pagination-flex-pc .paginationWrap ul').empty();
    $('#news-contents .pagination-flex-pc .paginationWrap ul').empty();
    $('.pagination-flex-sp .paginationWrap ul').empty();
}

clearContents = function() {
    // コンテンツをreflesh
    $('#columns-contents #page-columns').empty();
    $('#news-contents #page-news').empty();
}

// 取得した記事データを整形し画面に表示する
setArticle = function(json, type_id) {

    const typename = getTypeName(type_id);
    const page_block = $('div#page-'+typename).empty();
    if (json.data.length === 0) {
        page_block.append($("<div>記事が見つかりませんでした</div>"));
        clearPagination()
    }
    for(row in json.data)
    {
        const figure = json.data[row].figure;
        const publish_date = json.data[row].publish_date;
        const title = json.data[row].title;
        const tag_column = json.data[row].tag_column;
        
        const id = json.data[row].id;
    
        const box = $('<div class="column-box"></div>');
        const columns = $('<div class="column"></div>');
        const figure_link = $('<a class="column-detail-link-image" href="/columns/'+id+'"></a>');
        if (figure !== null) {
            const figure_url = figure.url;
            const figure_name = figure.name;
            const column_img = $('<img class="column-image" src="/storage/img/400_280/'+figure_url+'" alt="'+figure_name+'" loading="lazy" width="100%" height="100%">');
            figure_link.append(column_img);
            columns.append(figure_link);
        } else {
            const column_img = $('<img class="column-image" src="/storage/img/400_280/default_column_image.png" alt="デフォルトコラム画像" loading="lazy" width="100%" height="100%">');
            figure_link.append(column_img);
            columns.append(figure_link);
        }

        const post_date = $('<div class="column-post-date">'+publish_date+'</div>');
        const column_title = $('<div class="column-title">');
        const detail_link = $('<a class="column-detail-link" href="/columns/'+id+'"></a>');
        detail_link.text(title);
        column_title.append(detail_link);
        columns.append(post_date);
        columns.append(column_title);

        const column_tags = $('<div class="column-tags"></div>');
        if (tag_column !== undefined && tag_column.length !== 0) {
            for (idx in tag_column)
            {
                const wrapper_div = $('<div class="tag-block"></div>');
                const a_tag = $('<a></a>');
                a_tag.attr('class','column-tag');
                a_tag.attr('href','/columns?key=tag_id&value='+tag_column[idx].tag.id+'&type_id='+type_id);
                a_tag.text(tag_column[idx].tag.name);
                wrapper_div.append(a_tag);
                column_tags.append(wrapper_div);
            }
        }
        columns.append(column_tags);

        box.append(columns);
        page_block.append(box);
    }
}  

// 記事データ、ページネーションをセットする
setArticles = function(json, type_id='0') {
    // 既に記事がある場合削除しておく、ページネーションも削除する
    clear()
    json.map((element,idx) => {
        setArticle(element, idx)
    })
    if (json[0] === undefined) {
        $('#columns-contents').html('<div style="margin:12px">記事が見つかりませんでした</div>')
        $('#news-contents').html('<div style="margin:12px">記事が見つかりませんでした</div>')
    }
    if (json[0].total === 0 && json[1].total > 0) {
        type_id = '1'
        $('#news').prop('checked', true)
        $('#columns').prop('checked', false)
    } else if (json[1].total === 0 && json[0].total > 0) {
        type_id = '0'
        $('#columns').prop('checked', true)
        $('#news').prop('checked', false)
    }
    setArticleDataCount(json[0].total, json[1].total)
    setArticleCounts()
    setPagination(json[type_id], type_id)
}

// ページネーションをPC,スマホ両方に対応して表示する
setPagination = function(json, type_id) {
    //ページネーターを描画
    const current_page = json.current_page
    const next_page_url = json.next_page_url
    const prev_page_url = json.prev_page_url
    const last_page = json.last_page
    
    const typename = getTypeName(type_id)
    let pc_pagination = $('#'+typename+'-contents').children('.pagination-flex-pc').children('.paginationWrap').children('.pagination')
    let sp_pagination = $('.pagination-flex-sp .pagination')

    const paginations = generatePaginations(
        prev_page_url,
        current_page, 
        next_page_url, 
        last_page, 
        type_id
    )
    // スマホサイズ、PCサイズでそれぞれページネーションをセットする
    for(target of [pc_pagination, sp_pagination]) {
        if (paginations.prev !== undefined) {
            target.append(paginations.prev.clone())
        }
        // ページネーションのボタンの数だけループ
        paginations.links.forEach(v=>{
            if (v !== undefined) {
                target.append(v.clone())
            }
        })
        if (paginations.next !== undefined) {
            target.append(paginations.next.clone())
        }
    }
}

// ページネーションオブジェクトを生成する
generatePaginations = function(prev_page_url, current_page, next_page_url, last_page, type_id) {
    let paginations = {}
    // 一度に最大で5ページまでしか表示しないようにする
    const MAX_PAGINATION_LENGTH = 5
    // current_page-2,current_page-1,current_page,current_page+1,current_page+2 
    const PAGINATION_HALF_SIZE = MAX_PAGINATION_LENGTH / 2 | 0
    // 最後のページボタンが表示されているとき
    let end_page = last_page
    // ページネーションのボタンの表示最大数よりも表示しているページが大きく、最後のページボタンが表示されていないとき
    if (current_page > MAX_PAGINATION_LENGTH && (current_page + PAGINATION_HALF_SIZE < last_page)) {
        end_page = current_page + PAGINATION_HALF_SIZE 
    // 現在のページがページネーションの最大長以下で最後のページのボタンが表示されない
    } else if (current_page <= MAX_PAGINATION_LENGTH && last_page > MAX_PAGINATION_LENGTH) {
        end_page = MAX_PAGINATION_LENGTH
    }
    // ページネーションの最初のページ
    const start_page = (end_page - MAX_PAGINATION_LENGTH < 0) ? 0 : (end_page - MAX_PAGINATION_LENGTH)
    const prev_link_page = current_page-1
    
    //Prev 制御
    if(prev_page_url === null && start_page !== end_page) {
        paginations.prev = $("<li class='disabled'><a href=''>«</a></li>")
    } else if (prev_page_url !== null) {
        let prev_link_list = $("<li></li>")
        let prev_link = $('<a>«</a>')
        prev_link.attr('class', 'paginate-link')
        prev_link.attr('data-page', prev_link_page)
        prev_link.attr('data-type', type_id)
        prev_link_list.append(prev_link)
        paginations.prev = prev_link_list
    }

    //ページリンク
    let link_list = []
    for(let i = start_page; i < end_page; i++)
    {
        let link_page = i+1;
        const request = link_page
        let link = $("<a>"+link_page+"</a>")
        link.attr('class', 'paginate-link')
        link.attr('data-page', link_page)
        link.attr('data-type', type_id)
        //activeにするかどうか
        if(current_page == link_page)
        {
            link.attr('class', 'active')
        }
        link_list.push($("<li></li>").append(link))
    }
    paginations.links = link_list
    
    //Next制御
    if(next_page_url == null && last_page !== end_page) {
        paginations.next = $("<li class='disabled'><a href=''>»</a></li>")
    }else if (next_page_url !== null) {
        const next_link_page = current_page+1
        let next_link_list = $("<li></li>")
        let next_link = $("<a>»</a>")
        next_link.attr('class', 'paginate-link')
        next_link.attr('data-page', next_link_page)
        next_link.attr('data-type', type_id)
        next_link_list.append(next_link)
        paginations.next = next_link_list
    }
    return paginations
}